import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import classes from "./charts.module.css";
import { useSelector } from "react-redux";
import { useMerchantInvoiceDashboardOffline } from "../../../../offline";
import { formatCompactNumber } from "./chartPeriodUtils";

ChartJS.register(ArcElement, Tooltip, Legend);

const VendorStatusPie = () => {
  const Data = useSelector((state) => state.loginData.value);
  const auth_token = Data?.auth_token;
  const user_token = Data?.user?.token || Data?.user_token;
  const org_id = Data?.org_id || Data?.user?.org_id || Data?.organization_id;

  const { data: dashboardSummary } = useMerchantInvoiceDashboardOffline(
    auth_token,
    user_token,
    org_id
  );

  const statusData = dashboardSummary?.invoice_status_summary || null;

  if (!statusData) {
    return (
      <section className={classes.invoiceChartWrapper}>
        <div className={classes.chartHeader}>
          <div>
            <h2 className={classes.chartTitle}>Merchant Invoice Status</h2>
            <p className={classes.chartSubtitle}>Loading current status mix</p>
          </div>
        </div>
        <div className={classes.chartContainer}>
          <div className={classes.chartEmptyState}>Loading chart...</div>
        </div>
      </section>
    );
  }

  const statusItems = [
    { label: "Signed", value: Number(statusData?.signed || 0), color: "#0f766e" },
    { label: "Unsigned", value: Number(statusData?.unsigned || 0), color: "#7c3aed" },
    { label: "Approved", value: Number(statusData?.approved || 0), color: "#2563eb" },
    { label: "Rejected", value: Number(statusData?.rejected || 0), color: "#dc2626" },
  ];

  const totalStatusCount = statusItems.reduce((sum, item) => sum + item.value, 0);

  const chartData = {
    labels: statusItems.map((item) => item.label),
    datasets: [
      {
        label: "Invoices",
        data: statusItems.map((item) => item.value),
        backgroundColor: statusItems.map((item) => `${item.color}cc`),
        borderColor: statusItems.map((item) => item.color),
        borderWidth: 1,
        hoverOffset: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "68%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          color: "#29415f",
          padding: 18,
          font: {
            family: "gilroyMedium",
            size: 13,
          },
        },
      },
      tooltip: {
        backgroundColor: "rgba(9, 20, 42, 0.94)",
        borderColor: "rgba(120, 168, 255, 0.24)",
        borderWidth: 1,
        padding: 14,
        callbacks: {
          label: (context) =>
            `${context.label}: ${formatCompactNumber(context.raw || 0)}`,
        },
      },
    },
  };

  return (
    <section className={classes.invoiceChartWrapper}>
      <div className={classes.chartHeader}>
        <div>
          <h2 className={classes.chartTitle}>Merchant Invoice Status</h2>
          <p className={classes.chartSubtitle}>
            Current signed, unsigned, approved, and rejected distribution
          </p>
        </div>
      </div>

      <div className={classes.chartInsightStrip}>
        {statusItems.map((item) => (
          <div key={item.label} className={classes.chartInsightItem}>
            <span className={classes.chartInsightLabel}>{item.label}</span>
            <strong className={classes.chartInsightValue}>
              {formatCompactNumber(item.value)}
            </strong>
          </div>
        ))}
        <div className={classes.chartInsightItem}>
          <span className={classes.chartInsightLabel}>Total</span>
          <strong className={classes.chartInsightValue}>
            {formatCompactNumber(totalStatusCount)}
          </strong>
        </div>
      </div>

      <div className={classes.chartContainer}>
        <Doughnut data={chartData} options={options} />
      </div>
    </section>
  );
};

export default VendorStatusPie;
